<div class="zeva-card action-prompt">
  <div class="card-header action-header" [class.compress]="!prompts.title">
    <p class="mat-headline-2" style="width: 100%;">{{ prompts.title }}</p>

    <button
      mat-icon-button
      mat-dialog-close
      tabindex="-1"
      *ngIf="!prompts.disableClose"
      style="margin: -0.5rem -0.5rem 0 -0.5rem"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="card-body" style="height: fit-content">
    <div class="heading" *ngIf="prompts.heading || prompts.icon">
      <mat-icon class="icon" [svgIcon]="prompts.icon" *ngIf="prompts.icon" color="primary"></mat-icon>
      <p class="mat-headline-3" *ngIf="prompts.heading">{{ prompts.heading }}</p>
    </div>

    <div class="action left" *ngIf="prompts.message || prompts.messageTml || prompts.messages || prompts.centeredMessage">
      <p *ngIf="prompts.message">{{ prompts.message }}</p>
      <p *ngIf="prompts.centeredMessage" style="text-align: center;">{{ prompts.centeredMessage }}</p>
      <ng-container *ngIf="prompts.messages">
        <p *ngFor="let message of prompts.messages" class="messages">{{ message }}</p>
      </ng-container>
      <ng-container *ngIf="prompts.messageTml">
        <ng-container
          *ngTemplateOutlet="prompts.messageTml; context: prompts.messageContext"
        ></ng-container>
      </ng-container>
    </div>
  </div>

  <div class="card-footer action-footer">
    <button
      *ngIf="!prompts.removeCancelAction"
      mat-stroked-button
      color="primary"
      (click)="onCancel()"
      tabindex="-1"
    >
      {{ prompts.cancelActionCaption ?? 'Cancel' }}
    </button>

    <button
      *ngIf="prompts.otherActionCaption"
      mat-flat-button
      color="primary"
      (click)="onOther(prompts.otherActionCaption)"
      tabindex="-1"
    >
      {{ prompts.otherActionCaption }}
    </button>

    <button
      *ngIf="!prompts.removeConfirmAction"
      mat-flat-button
      color="primary"
      [disabled]="prompts.disableConfirmWhile ? prompts.disableConfirmWhile() : false"
      (click)="onConfirm()"
      tabindex="-1"
    >
      {{ prompts.confirmActionCaption ?? 'Confirm' }}
    </button>
  </div>
</div>
